import Charts from '../../components/analysis/Charts';
import { LakeDashboard } from '../../components/analysis/LakeDashboard';
import ChartArea from '../../components/custom/ChartArea';
import Chart from "react-apexcharts";
import { BackendService } from '../../lib/BackendService';
import Formats from '../../lib/Formats';
import Loading from '../../components/custom/Loading';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

export class DBWsCacheAnalysis extends LakeDashboard {

    static dashboardTitle() {
        return "WS cache statistics";
    }

    constructor(props) {
        super(props);

        this.YEARS=2;
        this.TOPS=10;
        this.mvalues=[1,2,3,4,5,6,7,8,9,10,11,12];
        this.mlabels=Formats.monthLabels();

        this.topRecordsSortings=[
            { value: "Total desc", label: "Sort: Total (top)", field: "Total" },
            { value: "Cached desc", label: "Sort: Cached (top)", field: "Cached" },
            { value: "Ratio desc", label: "Sort: Hit ratio (top)", field: "Ratio" },
            { value: "Ratio asc", label: "Sort: Hit ratio (bottom)", field: "Ratio" },
            { value: "NotCached desc", label: "Sort: Not Cached (top)", field: "NotCached" },
            { value: "NotCached asc", label: "Sort: Not Cached (bottom)", field: "NotCached" }
        ];

        let af=props.analysisField;
        if(!af) af="Quantity";

        Object.assign(this.state,{
            computeMode: 'CACHED',
            topRecords: null,
            filtersCollapsed: true,
            enableBottomFilter: true,
            analysisField: af,
            topRecordsSorting: this.topRecordsSortings[0].value
        });
    }

    setup() {
        console.log("db state",this.state);
        if(!this.state.dashboardConfiguration.FilterCharts) {
            this.state.dashboardConfiguration.FilterCharts=["TourOperator","Operation","Server","Version"];
        }

        // Setup dashboard
        let db={
            charts: {
                year: Charts.donut("year",(c) => this.clickOnChart(c)),
                month: Charts.bar("month",this.mvalues,(c) => this.clickOnChart(c)),
            }
        };
        let mlbls=this.mlabels;
        db.charts.month.options.xaxis.labels={
            formatter: function (value) {
                return mlbls[parseInt(value)-1];
            }
        };
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Configuring filter chart '" + fc + "'");
            db.charts[fc]=Charts.donut(fc,(c) => this.clickOnChart(c));
        }

        this.setState({ 
            dashboard: db
        });
    }
    
    changeComputeMode(e) {
        console.log("swith to",e.target.value);
        this.setState({
            computeMode: e.target.value
        })
        setTimeout(() => {
            this.destroy_crossfilter();
            this.fetchDashboard();
        },10)
    }

    loadData() {
        let fields=["Year","Month"];
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            fields.push(Charts.keyToField(fc));
        }

        let pars={
            FromYear: new Date().getFullYear()-this.YEARS,
            Fields: fields.join(','),
            ComputeMode: this.state.computeMode
        }
        BackendService.call("analysis/wsCacheAnalytics",pars).then((s) => {
            let c=JSON.parse(s);
            console.log("raw data",c);
            this.dataLoaded(c.Analitics.Entities);
            this.loadTopRecords();
        });
    }

    prepareDimensionsAndGroups() {          
        this.state.crossfilter.createBasicDimension("year","Year",true);
        this.state.crossfilter.createBasicDimension("month","Month",true);
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Preparing dimension '" + fc + "' on '" + Charts.keyToField(fc) + "'");
            this.state.crossfilter.createBasicDimension(fc,Charts.keyToField(fc),true);
        }

        if(this.state.showBottoms) {
            for(let fc of this.state.dashboardConfiguration.FilterCharts) {
                console.log("Computing top " + this.TOPS + " on '" + fc + "'");
                this.state.crossfilter.computeTops(fc,this.TOPS,this.state.analysisField,true);
            }
        }        
    }

    feedDonut(key) {
        let cf=this.state.crossfilter;
        let data=cf.topValuesToSerie(key,this.TOPS,this.state.analysisField,this.state.dashboard.showBottoms);

        let db=this.state.dashboard;   
        console.log("feedDonut",key,data);
        db.charts[key].series=data.series;
        let opts={}
        if(db.charts[key].options)
            opts=Object.assign({}, db.charts[key].options);
        opts.labels=data.labels;
        db.charts[key].options=opts;
    }

    computeChartData() {      
        let db=this.state.dashboard;   
        let cf=this.state.crossfilter; 
        
        this.feedDonut("year");

        let notCachedPerMonth=[];
        for(let m=1;m<=12;m++)
        notCachedPerMonth.push(0);
        let reduced=cf.groups.month.reduceSum(i => i["Quantity"]);
        reduced.all().forEach(i => {
            notCachedPerMonth[i.key-1]=i.value;
        });

        // Cached
        let cachedPerMonth=[];
        for(let m=1;m<=12;m++)
        cachedPerMonth.push(0);
        let reducedCached=cf.groups.month.reduceSum(i => i["Cached"]);
        reducedCached.all().forEach(i => {
            cachedPerMonth[i.key-1]=i.value;
        });

        let newSeries=[
            {   
                name: "Not cached",
                data: notCachedPerMonth 
            },
            {   
                name: "Cached",
                data: cachedPerMonth 
            }
        ];
        db.charts.month.series=newSeries;

        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Computing data for filter chart '" + fc + "'");
            this.feedDonut(fc);
        }
    }

    loadTopRecords(sortMode) {
        if(!sortMode) sortMode=this.state.topRecordsSorting;
        this.setState({
            topRecords: null,
            selectedArticle: null,
            topRecordsSorting: sortMode
        })
        
        let pars={
            FromYear: new Date().getFullYear()-this.YEARS,
            Fields: ["TourOperator","Operation"].join(','),
            OrderBy: sortMode,
            ComputeMode: this.state.computeMode
        }

        let activeFilters=[];
        for(var dk in this.state.crossfilter.filters) {
            let fdim=this.state.crossfilter.activeFilters(dk);
            if(fdim) {
                activeFilters.push(Charts.keyToField(dk));
                
                let includes=[];
                let ip=0;
                let ddk=dk;
                fdim.forEach(e => {
                    if(e===this.state.crossfilter.getLabel_Others()) return;
                    let ev=e;
                    pars[Charts.keyToField(ddk) + "_i_" + ip]=ev;
                    includes.push(ev);
                    ip++;
                });

                let im=0;
                fdim.forEach(e => {
                    if(e!==this.state.crossfilter.getLabel_Others()) return;
                    this.state.crossfilter.topRecords[ddk].forEach(s => {
                        if(includes.indexOf(s)>=0) return;
                        pars[Charts.keyToField(ddk) + "_e_" + im]=s;
                        im++;
                    });
                });
            }
        }
        pars["ActiveFilters"]=activeFilters.join(',');

        BackendService.call("analysis/wsCacheRecords",pars).then((s) => {
            let c=JSON.parse(s);
            console.log("top records",c);
            this.setState({
                topRecords: c.CacheRecords.Entities
            })
        });
    }

    filterChanged(key,sel) {        
        this.feedDonut("year");
        for(let fc of this.state.dashboardConfiguration.FilterCharts) {
            console.log("Computing data for filter chart '" + fc + "'");
            this.feedDonut(fc);
        }
        this.loadTopRecords();
    }

    getTopSorting() {
        let res=null;
        this.topRecordsSortings.forEach(e => {
            if(e.value==this.state.topRecordsSorting) res=e;
        });
        return res;
    }

    charts() {
        let topLbl=" (top " + this.TOPS + ")";

        let topRecords=[];
        if(this.state.topRecords) {
            topRecords=this.state.topRecords.map((e,i) => {
                let perc=0;
                if(e["Total"]!=0) 
                    perc=e["Cached"] / e["Total"] * 100;
                let cached=Formats.quantity(e["Cached"]);
                let total=Formats.quantity(e["Total"]);
                return (
                    <tbody key={i} className="hotel clickable" onClick={(evt) => this.expandArticle(e,evt)}>
                        <tr>
                            <td>
                                <div className="hotel-name">{e.TourOperator}</div>
                                <div className="description">{e.Operation}</div>
                            </td>
                            <td>
                                <div className="markup">{cached}</div>
                                <div className="markup">{total}</div>
                            </td>
                            <td>
                                <div className="total">{Formats.quantity(perc)}%</div>
                                <div className="markup"></div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan={3}>
                                <div style={{width:'100%',background:"#eee",height:'4px',borderRadius:'2px'}}>
                                    <div style={{width:perc + "%",background:'rgb(0, 227, 150)',height:'4px'}}></div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                );
            });
        }

        let fcharts=[];
        if(this.state.dashboard) {
            for(let fc of this.state.dashboardConfiguration.FilterCharts) {
                fcharts.push(
                    <div key={fc} style={{display:'inline-block',marginRight:'10px'}}>
                        <ChartArea title={"On " + Charts.keyToLabel(fc) + topLbl} 
                                        onSearch={() => this.showFilterSearch({ label: Charts.keyToLabel(fc),value: fc}) }>
                            <Chart 
                                options={this.state.dashboard.charts[fc].options} 
                                series={this.state.dashboard.charts[fc].series}
                                type="donut" width="350"
                                />
                        </ChartArea>
                    </div>
                );
            }
        }

        let tsSortItems=this.topRecordsSortings.map((s) => {
            return (
                <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
            )
        });

        return (
            <div className="charts-container" style={{flexDirection:"column"}}>
                <div style={{width:'100%',marginBottom:'8px',marginTop:'4px'}}>
                    <FormControl size='small' className="db-selector">
                        <InputLabel id="cm-select-label">Compute mode</InputLabel>
                        <Select labelId="cm-select-label" placeholder="[No selection]" onChange={(e) => this.changeComputeMode(e)} value={this.state.computeMode}>
                            <MenuItem value="ALL">On all tour operators</MenuItem>
                            <MenuItem value="CACHED">On cached tour operators</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div style={{display:"flex"}}>
                    <div>
                        <ChartArea style={{width:'1140px'}} title="On call date">
                            <div className="inline-chart">
                                <Chart 
                                    options={this.state.dashboard.charts.year.options} 
                                    series={this.state.dashboard.charts.year.series}
                                    type="donut" width="300" 
                                    />
                            </div>
                            <div className="inline-chart">
                                <Chart 
                                    options={this.state.dashboard.charts.month.options} 
                                    series={this.state.dashboard.charts.month.series}
                                    type="bar" width="750" height="200"
                                    />
                            </div>
                        </ChartArea>
                        <div style={{verticalAlign:'top',width:'1200px'}}>
                            {fcharts}
                        </div>
                    </div>
                    <div style={{flexGrow:2}}>
                        <div className="chart-area" style={{width:'95%'}}>
                            <div className="chart-title">
                                {"Details (top 50)"}
                                <div onClick={()=>this.exportTableToExcel('topsellers-table','top_records')} className="btn-2-excel link" style={{float:"right"}}>
                                    <TextSnippetIcon />
                                </div>
                            </div>
                            <div>
                                { !this.state.topRecords &&
                                    <Loading message="Loading details..." />
                                }
                                { this.state.topRecords &&
                                    <div>
                                        <div style={{borderBottom:'1px solid #ddd',paddingBottom:'4px'}}>
                                            <Select size="small" onChange={(e) => this.loadTopRecords(e.target.value)} value={this.state.topRecordsSorting} >
                                                {tsSortItems}
                                            </Select>
                                        </div>
                                        <div className="top-sellers articles compact">
                                            <table id="topsellers-table">
                                                <tbody>
                                                    {topRecords}
                                                </tbody>
                                            </table>                            
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>    
                </div>                                 
            </div>
        );
    }

}
